
      var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 81,
  viewBox: "0 0 80 81",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M40 9.967c16.834 0 30.533 13.699 30.533 30.533 0 16.834-13.699 30.533-30.533 30.533-16.834 0-30.533-13.699-30.533-30.533C9.467 23.666 23.166 9.967 40 9.967Z",
  fill: "var(--theme-light,#e2cff7)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.933
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.433 25.719 40 46.874l1.567-21.155a1.571 1.571 0 1 0-3.134 0Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3.333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 55.5,
  r: 3,
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"80\" height=\"81\" viewBox=\"0 0 80 81\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M40 9.9668C56.8345 9.9668 70.5332 23.6655 70.5332 40.5C70.5332 57.3345 56.8345 71.0332 40 71.0332C23.1655 71.0332 9.4668 57.3345 9.4668 40.5C9.4668 23.6655 23.1655 9.9668 40 9.9668Z\" fill=\"var(--theme-light,#e2cff7)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.93333\"/>\r\n<path d=\"M38.4331 25.7187L40.0002 46.874L41.5672 25.7187C41.6347 24.8076 40.9137 24.0312 40.0002 24.0312C39.0866 24.0312 38.3656 24.8076 38.4331 25.7187Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"40\" cy=\"55.5\" r=\"3\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/error.0f0b58678f393c98e275c534c917830c.svg"),
        {
          React: SvgError,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      